var actionTypes = require('../../../actionTypes.js');

module.exports.createAction = (payload)=> (
            {
                type: actionTypes.attachmentFormUI,
                payload: payload
            }
           )

module.exports.changeState = (previousState, payload)=> Object.assign({}, previousState, {attachmentForm: payload})